import type from "./type";

export default type("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-request/src/json.js
// module id = 402
// module chunks = 0